import { searchIncludes, type TinyCompany } from '@terros/common'
import { useCompanies } from './list'

const MIN_NAME_LENGTH = 2
const MAX_SUGGESTIONS = 5

export type ExistingCompaniesListProp = {
  name: string
}

export type UseExistingCompaniesResult = {
  companies: TinyCompany[]
  isLoading: boolean
}

export const useExistingCompanies = ({ name }: ExistingCompaniesListProp): UseExistingCompaniesResult => {
  const { data: companies = [], isFetching } = useCompanies()
  const query = name.trim()
  if (query.length < MIN_NAME_LENGTH) return { companies: [], isLoading: isFetching }

  const matches = companies
    .filter((company) => searchIncludes([company.name], query))
    .slice(0, MAX_SUGGESTIONS)

  return { companies: matches, isLoading: isFetching }
}
